import { DemoUserListObject, usersListArray } from "assets/data/usersData";
import { UserList, MessageCommunityModal } from "components";
import { useState } from "react";
import { Link } from "react-router-dom";
import { CardFilter } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

const Users = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const [users, setUsers] = useState(usersListArray);

    const handleDelete = (id: string | number) => {
        setUsers(() =>
            users.map((i) => (i.id !== id ? i : { ...i, status: "deleted" }))
        );
    };
    const handleBlock = (id: string | number) => {
        setUsers(() =>
            users.map((i) => (i.id !== id ? i : { ...i, status: "blocked" }))
        );
    };
    const handleRestore = (id: string | number) => {
        setUsers(() =>
            users.map((i) => (i.id !== id ? i : { ...i, status: "active" }))
        );
    };

    // send message modal
    const [openModal, setOpenModal] = useState(false);
    const [modalUser, setModalUser] = useState<DemoUserListObject>();

    const handleSendMsg = (user: DemoUserListObject) => {
        setOpenModal(true);
        setModalUser(user);
    };

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Users"
                            />
                            <h1 className="font-medium text-lg dark:text-white py-8">
                                Users
                            </h1>
                        </div>
                        <div className="flex justify-center items-end flex-col w-full px-3 md:px-10 gap-5">
                            <div className="box-heading w-full flex justify-center items-center gap-5 px-10  lg:px-20 py-2">
                                <Link
                                    className="link-style-1 px-5 py-1 is-active"
                                    to="/users"
                                    style={{ minWidth: 90 }}
                                >
                                    All
                                </Link>
                                <Link
                                    className="link-style-1 px-5 py-1"
                                    to="/users/block"
                                    style={{ minWidth: 90 }}
                                >
                                    Blocked
                                </Link>
                                <Link
                                    className="link-style-1 px-5 py-1"
                                    to="/users/delete"
                                    style={{ minWidth: 90 }}
                                >
                                    Deleted
                                </Link>
                            </div>
                            <div className="px-3 md:w-fi">
                                <CardFilter
                                    dropDownItems={[
                                        "By Full Name",
                                        "By User ID",
                                        "By About Me",
                                        "By Country",
                                        "By Topics"
                                    ]}
                                    showFullTitle
                                />
                            </div>
                        </div>

                        <div className="w-full justify-center items-start flex flex-wrap gap-5 py-10 px-10 ">
                            {users.length ? (
                                users.map((i) => (
                                    <UserList
                                        listItem={i}
                                        className="w-full md:w-1/2 lg:w-1/4 xl:w-1/5"
                                        key={i.id}
                                        handleBlock={handleBlock}
                                        handleDelete={handleDelete}
                                        handleRestore={handleRestore}
                                        handleSendMsg={handleSendMsg}
                                    />
                                ))
                            ) : (
                                <h2 className="dark:text-white font-bold text-lg">
                                    Empty
                                </h2>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            {modalUser && (
                <MessageCommunityModal
                    open={openModal}
                    setOpen={setOpenModal}
                    user={modalUser}
                />
            )}
        </>
    );
};

export default Users;
